import { useTranslations } from "next-intl";
import { useIsCartModalOpen, usePendingCart, useCloseCartModal } from "@hooks/use-cart";
import { Button, Link, Modal } from "@components/core";
import CartModalFooter from "./CartModalFooter";
import CartItemsList from "./CartItemsList";

function CartModal() {
  const t = useTranslations("common");

  const isCartModalOpen = useIsCartModalOpen();
  const pendingCart = usePendingCart();
  const closeCartModal = useCloseCartModal();

  const cartItemsLength = pendingCart?.cart_items?.length;

  function displayEmptyCartContent() {
    return (
      <section>
        <p className="mb-0" data-testid="cart-modal-empty-content">
          {t("cart_modal.empty_cart_description")}
        </p>
        <div className="m-3">
          <Link
            href="/braderie"
          >
            <Button
              fullWidth
              onClick={closeCartModal}
              data-testid="cart-modal-go-to-sales-page-button"
            >
              {t("cart_modal.go_to_sales_page")}
            </Button>
          </Link>
        </div>
      </section>
    );
  }

  function displayCartContent() {
    return (
      <section>
        <p>{t("cart_modal.cart_items_recap", { count: cartItemsLength })}</p>

        <CartItemsList
          cartItems={pendingCart.cart_items}
          isCartItemRemovable
        />
      </section>
    );
  }

  return (
    <Modal
      show={isCartModalOpen}
      onHide={closeCartModal}
      title={t(cartItemsLength >= 1 ? "cart_modal.title" : "cart_modal.empty_cart")}
      Footer={<CartModalFooter />}
    >
      <div className="d-flex flex-column p-3">
        {cartItemsLength >= 1 ? displayCartContent() : displayEmptyCartContent()}
      </div>
    </Modal>
  );
}

export default CartModal;
